import React, { useState, useEffect } from 'react';
import { getPlans } from '../Videoapi/Videoapi';
import './Videoapi.css';

export default function AdminPlans() {
  const [plans, setPlans] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    getPlans()
      .then(r => setPlans(r.data.data))
      .catch(() => setToast({ msg: 'Failed to load plans', type: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="plans-root">
      <div className="plans-header">
        <div>
          <h1 className="plans-header-title">💰 Plans Overview</h1>
          <p className="plans-header-sub">Available subscription plans for users</p>
        </div>
      </div>

      <div className="plans-content">
        {loading ? (
          <div className="loading-spinner"><div className="spinner" /></div>
        ) : (
          <>
            <div className="stats-row">
              <div className="stat-card">
                <div className="stat-value">{plans?.categoryPlans?.length || 0}</div>
                <div className="stat-label">Category Plans</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">1</div>
                <div className="stat-label">All Access Plan</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">₹{(plans?.allAccessPlan?.price || 25000).toLocaleString('en-IN')}</div>
                <div className="stat-label">All Access Price</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">{plans?.allAccessPlan?.days || 365}d</div>
                <div className="stat-label">All Access Duration</div>
              </div>
            </div>

            {plans?.allAccessPlan && (
              <>
                <p className="plans-section-title">🌟 All Access Plan</p>
                <div className="plans-grid">
                  <div className="plan-card all-access">
                    <div className="plan-accent" />
                    <span className="plan-type-badge all">All Access</span>
                    <div className="plan-name">🌟 All Access Plan</div>
                    <p className="plan-desc">{plans.allAccessPlan.description}</p>
                    <div className="plan-pricing">
                      <span className="plan-price">₹{plans.allAccessPlan.price.toLocaleString('en-IN')}</span>
                      <span className="plan-period">/ {plans.allAccessPlan.days} days</span>
                    </div>
                    <div className="plan-meta">
                      <span className="badge badge-green">1 Year Access</span>
                      <span className="badge badge-green">All Categories</span>
                      <span className="badge badge-green">All Videos</span>
                    </div>
                  </div>
                </div>
              </>
            )}

            {plans?.categoryPlans?.length > 0 && (
              <>
                <p className="plans-section-title">📂 Category Plans</p>
                <div className="plans-grid">
                  {plans.categoryPlans.map((plan, i) => (
                    <div className="plan-card" key={i}>
                      <div className="plan-accent" />
                      <span className="plan-type-badge cat">Category Plan</span>
                      <div className="plan-cat-img">
                        {plan.image?.url ? <img src={plan.image.url} alt={plan.category} /> : '📁'}
                      </div>
                      <div className="plan-name">{plan.category}</div>
                      <p className="plan-desc">{plan.description || 'All videos in this category'}</p>
                      <div className="plan-pricing">
                        <span className="plan-price">₹{plan.price}</span>
                        <span className="plan-period">/ {plan.days} days</span>
                      </div>
                      <div className="plan-meta">
                        <span className="badge badge-sky">{plan.days} days</span>
                        <span className="badge badge-sky">{plan.category} only</span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </div>

      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </div>
  );
}